import { TEMPLATE_PAGE_TYPE } from "components/FormerEditor/common/constants/entity";
import { COLORS } from "utils/styles";

const PAGE_TEMPLATE = "page";
const LINK_TEMPLATE = "link";
const PRODUCT_TEMPLATE = "product";
export const TEMPLATE_TYPE = {
  PAGE: PAGE_TEMPLATE,
  PRODUCT: PRODUCT_TEMPLATE,
  LINK: LINK_TEMPLATE
};

// Common
const PRODUCTS = "PRODUCTS";
const PRICES = "PRICES";
// Pages
const BLOCKS = "BLOCKS";
const FEATURES = "FEATURES";
// Links
const LINKS = "LINKS";

const DETAILS = "DETAILS";
const AUDIENCE = "AUDIENCE";
const SEND = "SEND";

const NEW = "new";
const COPY = "copy";
export const TEMPLATE_ACTION = {
  NEW,
  COPY
};

export const ALL_TEMPLATE_PAGE_BUILDER_SECTIONS = {
  BLOCKS,
  PRODUCTS,
  PRICES,
  FEATURES
};

export const TEMPLATE_PRODUCT_TEMPLATES_TAB = {
  [TEMPLATE_PAGE_TYPE.PRICING]: true
};

export const TEMPLATE_NEW_PRODUCT_TAB = {
  [TEMPLATE_PAGE_TYPE.PRICING]: true
};

export const TEMPLATE_PRODUCTS_TAB = {
  [TEMPLATE_PAGE_TYPE.PRICING]: true,
  [TEMPLATE_PAGE_TYPE.STORE]: true
};

export const TEMPLATE_PAGE_TYPE_BUILDER_SECTIONS = {
  [TEMPLATE_PAGE_TYPE.PRICING]: { BLOCKS, PRODUCTS, PRICES, FEATURES },
  [TEMPLATE_PAGE_TYPE.TIP]: { BLOCKS },
  [TEMPLATE_PAGE_TYPE.FORM]: { BLOCKS },
  [TEMPLATE_PAGE_TYPE.STORE]: { BLOCKS, PRODUCTS }
};

export const TEMPLATE_CAMPAIGN_BUILDER_SECTIONS = {
  DETAILS,
  AUDIENCE,
  SEND
};

export const TEMPLATE_LINK_BUILDER_SECTIONS = { LINKS };

const MEDAL = "medal";
const DOLLAR = "dollar";
export const TEMPLATE_COLOR_UID_MAP = {
  [MEDAL]: COLORS.gold,
  [DOLLAR]: COLORS.forest_green
};

export const TEMPLATE_PRODUCT_PICKER_TABS = {
  PRODUCT: "product",
  TEMPLATE: "template",
  NEW: "new"
};

export const TEMPLATE_CAMPAIGN_AUDIENCE_INTENT = {
  AUDIENCE: "audience",
  NEW_AUDIENCE: "new_audience",
  NEW_DATASOURCE: "new_datasource"
};

const SCRATCH = "scratch";
const FORM_FIELDS = "form_fields";
const PREFILL = "prefill";
const CONNECT = "connect";
const DISCOUNTS = "discounts";
const PAYMENT = "payment";
const PAYMENT_METHODS = "payment_methods";
const LEGAL = "legal";
const LOGIC = "logic";
const TAXES = "taxes";
const SHIPPING = "shipping";
const INSTALLMENTS = "installments";
export const TEMPLATE_CATEGORY = {
  SCRATCH,
  FORM_FIELDS,
  PREFILL,
  CONNECT,
  DISCOUNTS,
  PAYMENT_METHODS,
  LEGAL,
  LOGIC,
  INSTALLMENTS,
  SHIPPING,
  TAXES,
  PAYMENT
};

export const ORDERED_TEMPLATE_CATEGORIES = [
  FORM_FIELDS,
  PAYMENT,
  PAYMENT_METHODS,
  DISCOUNTS,
  PREFILL,
  CONNECT,
  LEGAL,
  LOGIC,
  INSTALLMENTS,
  SHIPPING,
  TAXES
];

export const TEMPLATE_CATEGORY_DESCRIPTIONS = {
  [FORM_FIELDS]:
    "Add a variety of form fields to your checkout pages to capture the data you need.",
  [PREFILL]: "Configure form field pre-fill using query string params",
  [CONNECT]: "Forward your form field data through to Stripe checkout.",
  [DISCOUNTS]: "Pre-apply coupons or allow promotion codes at checkout.",
  [PAYMENT_METHODS]: "Select the type of payment methods you need for checkout",
  [LEGAL]: "Show required legal notices and capture consent at checkout time.",
  [LOGIC]:
    "Configure your form with logic to describe what products are included in checkout.",
  [INSTALLMENTS]:
    "Allow your customers to pay in installments through our payment plan configuration.",
  [SHIPPING]: "Configure shipping rates and acceptable destination",
  [TAXES]: "Set individual tax rates or enable automatic taxes",
  [PAYMENT]: "Save payment method details, authorize payment and more."
};

export const TEMPLATE_BLANK_PAGE_UUID = "efffc2ea-597e-4071-8b71-6909a950d9a6";
